import React, { useState } from "react";
import {
    Dialog, DialogTitle, DialogContent, DialogActions,
    Button, TextField, MenuItem, Select, FormControl,
    InputLabel, RadioGroup, FormControlLabel, Radio,
    Box,
    Typography,
    Modal,
    Backdrop,
    Fade,
    IconButton,
    Drawer,
    useTheme,
    useMediaQuery,
    Avatar
} from "@mui/material";
import BASE_URL, { COMMUNITYADMINS } from "../../NetworkConfig/ApiConfig";
import { CloseRounded } from "@mui/icons-material";
import { CircleLoader, BounceLoader, ClipLoader } from 'react-spinners'




const ApplicationDetailPopup = ({ open, onClose, width = 420, onComplete = () => { }, questions = [], data = {} }) => {

    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down("md"));
    const [spaceName, setSpaceName] = useState("")
    const [spaceDescription, setSpaceDescription] = useState("")
    const [spaceSupportMail, setSpaceSupportMail] = useState("")
    const [spaceType, setSpaceType] = useState("")
    const [loading, setLoading] = useState(false)

    const dpr = window.devicePixelRatio || 1;




    return (
        <Drawer
            anchor={isMobile ? "bottom" : "right"}
            open={open}
            onClose={onClose}
            PaperProps={{
                sx: {
                    width: isMobile ? "100%" : 420,
                    height: isMobile ? "85vh" : "100vh",
                    borderRadius: isMobile ? "20px 20px 0 0" : 0,
                    background: "#0f0e0fff",
                    flexDirection: 'column',
                    display: 'flex'
                }
            }}
        >



            {/* Body */}
            <Box sx={styles.body}>
                <Box sx={styles.header}>
                    <IconButton onClick={onClose}>
                        <CloseRounded />
                    </IconButton>
                    <span style={styles.title}>{"Application Details"}</span>

                </Box>


                <Box
                    sx={{
                        flexDirection: "row", alignItems: "center", display: "flex",
                        background: "#ffffff08",
                        paddingInline: "15px",
                        paddingBlock: "10px",
                        borderRadius: "15px",
                        marginTop: "10px",
                        gap: "10px",
                        marginInline: "15px"
                    }} >

                    <Box sx={{
                        width: 40,
                        height: 40,
                        borderRadius: "50%",
                        overflow: "hidden",
                        flexShrink: 0,
                    }}>
                        <Avatar
                            src={data?.user?.image[0] ?? ""}
                            imgProps={{
                                referrerPolicy: "no-referrer",
                                decoding: "async",
                                style: {
                                    width: `${40 * dpr}px`,
                                    height: `${40 * dpr}px`,
                                    transform: `scale(${1 / dpr})`,
                                    transformOrigin: "top left",
                                    imageRendering: "auto"
                                }
                            }}
                            sx={{
                                width: 40,
                                height: 40,
                                border: "2px solid #ffffff05",
                                bgcolor: "#111",
                            }}
                        />
                    </Box>

                    <Box sx={{
                        flexDirection: "column",
                        display: "flex",
                        flex: 1
                    }} >

                        <Typography color={"#ffffff"}
                            fontFamily={"poppins-reg"}
                            style={{
                                display: "flex",
                                flexDirection: "row",
                                alignItems: "center",
                            }}
                            fontSize={"14px"}>{data?.user?.full_name ?? ""}</Typography>
                        <Typography color={"#aaaaaa"}
                            fontFamily={"poppins-reg"}
                            style={{
                                display: "flex",
                                flexDirection: "row",
                                alignItems: "center",
                            }}
                            fontSize={"12px"}>{data?.user?.buzz_name ?? ""}</Typography>

                    </Box>

                </Box>

                <Typography style={{
                    fontSize: "12px",
                    fontFamily: "poppins-reg", color: "#ffffff",
                    marginInline: "18px", marginTop: "20px", marginBottom: "4px"
                }}>{"Form Response"}</Typography>

                <Box
                    sx={{
                        flexDirection: "column", display: "flex",
                        background: "#ffffff08",
                        paddingInline: "15px",
                        paddingBlock: "10px",
                        borderRadius: "15px",
                        position: "relative",
                        alignSelf: "stretch",
                        marginTop: "5px",
                        gap: "10px",
                        overflow: "hidden",
                        marginInline: "15px"
                    }} >

                    {
                        data?.response?.map((item, index) => (

                            <Box sx={{
                                display: "flex", flexDirection: "column", alignSelf: "stretch", position: "relative",

                            }} >
                                <Typography
                                    sx={{
                                        fontSize: "12px",
                                        fontFamily: "poppins-reg",
                                        color: "#ffffff90",
                                        wordBreak: "break-word",
                                        overflowWrap: "anywhere",
                                        whiteSpace: "normal",
                                    }}
                                >
                                    {questions.find(q => q._id == item.questionId)?.question
                                        ?? item.questionId
                                        ?? "Question not found"}
                                </Typography>

                                <Typography

                                onClick={() => {
                                    if(item.answer.startsWith("http")){
                                        window.open(item.answer, "_blank")
                                    }
                                }}
                                    sx={{

                                        cursor: item.answer.startsWith("http") ? "pointer" : "default",
                                        fontSize: "14px",
                                        fontFamily: "poppins-reg",
                                        color: item.answer.startsWith("http") ? "#943bff" : "#ffffff",
                                        wordBreak: "break-word",
                                        overflowWrap: "anywhere",
                                        whiteSpace: "normal",
                                    }}
                                >
                                    {item.answer.startsWith("http") ? "View File" : item.answer}
                                </Typography>

                            </Box>
                        ))
                    }


                </Box>


            </Box>
        </Drawer>

    );
};

const styles = {
    popup: (width) => ({
        position: "absolute",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        width,
        maxWidth: "90%",
        maxHeight: "85vh",
        bgcolor: "#0f0f0f",
        borderRadius: 3,
        boxShadow: 24,
        overflow: "hidden"
    }),
    header: {
        display: "flex",
        alignItems: "center",
        px: 1,
        py: 2,
        borderBottom: "1px solid #aaaaaa20"
    },
    title: {
        fontSize: "14px",
        fontFamily: "poppins-reg"
    },
    body: {
        overflowY: "auto",
        display: 'flex',
        flexDirection: 'column',
        flex: 1
    }
};


export default ApplicationDetailPopup;
